import TronStation from 'tronstation'
import TronWeb from 'tronweb'
import { formatSmartBalance } from 'lib/format'
import { get } from 'lib/api'
import { toBN } from 'lib/format'

export let tronWeb: TronWeb
export let tronStation

export async function initTron() {
  if (window['tronWeb']) {
    tronWeb = window['tronWeb'] as TronWeb
    tronStation = new TronStation(tronWeb)
  }
  if (tronWeb && tronStation) return [tronWeb, tronStation]
  const imToken = window['imToken']
  const providerUrl = await imToken.callPromisifyAPI('tron.getProvider')
  tronWeb = new TronWeb({fullHost: providerUrl || "https://api.trongrid.io"})
  tronStation = new TronStation(tronWeb)
  return [tronWeb, tronStation]
}

export function getTronWeb(): TronWeb {
  return tronWeb
}

// https://developers.tron.network/reference#getaccount
export function getAccount(address: string) {
  return tronWeb.trx.getAccount(address)
}

export async function getAccountResources(address: string) {
  const account = await getAccount(address)
  const resource = await tronWeb.trx.getAccountResources(address)

  const balance = account.balance
  const freebp = resource.freeNetLimit || 0
  const freebpUsed = resource.freeNetUsed || 0
  const frozenbp = resource.NetLimit || 0
  const frozenbpUsed = resource.NetUsed || 0
  const totalbp = freebp + frozenbp
  const totalbpUsed = freebpUsed + frozenbpUsed
  const totalEnergy = resource.EnergyLimit || 0
  const totalEnergyUsed = resource.EnergyUsed || 0

  return {
    account: account,
    resource: {
      balance,
      freebp,
      freebpUsed,
      frozenbp,
      frozenbpUsed,
      totalbp,
      totalbpUsed,
      totalEnergy,
      totalEnergyUsed,
      TotalNetLimit: resource.TotalNetLimit,
      TotalNetWeight: resource.TotalNetWeight,
      TotalEnergyWeight: resource.TotalEnergyWeight,
      TotalEnergyLimit: resource.TotalEnergyLimit || 10e10,
    }
  }
}

// us/day
export const formatResource = (value, resourceType) => {
  if (value === 0) return 0
  return formatSmartBalance(value, 2, 4)
}

export const getV2StakedTrx = (info) => {
  const [bandwidth, energy] = info?.frozenV2 || [null, null]
  const bp = bandwidth?.amount ? TronWeb.fromSun(bandwidth.amount) : 0
  const energyTotal = energy?.amount ? TronWeb.fromSun(energy.amount) : 0

  const acquired_delegate_bp = info?.acquired_delegated_frozenV2_balance_for_bandwidth || 0
  const acquired_delegate_energy = info?.account_resource?.acquired_delegated_frozenV2_balance_for_energy || 0

  const energyFromOthers = TronWeb.fromSun(acquired_delegate_energy || 0)
  const bandwidthFromOthers = TronWeb.fromSun(acquired_delegate_bp || 0)

  return {
    energy: toBN(energyTotal).plus(energyFromOthers).toFixed(),
    self_energy: energyTotal,
    d_energy: energyFromOthers,
    bp: toBN(bp).plus(bandwidthFromOthers).toFixed(),
    self_bp: bp,
    d_bp: bandwidthFromOthers
  }
}

export const getResourceDistributionInTrx = (info) => {
  const acquired_delegate_bp = info?.acquired_delegated_frozen_balance_for_bandwidth || 0
  const acquired_delegate_energy = info?.account_resource?.acquired_delegated_frozen_balance_for_energy || 0

  const frozen_energy = info?.account_resource?.frozen_balance_for_energy?.frozen_balance || 0
  const self_energy = TronWeb.fromSun(frozen_energy || 0)
  const d_energy = TronWeb.fromSun(acquired_delegate_energy || 0)
  const energy = toBN(self_energy).plus(d_energy).toFixed()

  let frozen_bp = 0
  if (info && Array.isArray(info.frozen)) {
    info.frozen.forEach(f => {
      frozen_bp = toBN(frozen_bp).plus(f.frozen_balance).toFixed()
    })
  }
  const d_bp = TronWeb.fromSun(acquired_delegate_bp || 0)
  const self_bp = TronWeb.fromSun(frozen_bp)
  const bandwidth = toBN(self_bp).plus(d_bp).toFixed()

  return {
    energy,
    self_energy,
    d_energy,
    bp: bandwidth,
    self_bp,
    d_bp,
  }
}

export const getDelegatedResource = async (from, to) => {
  const imToken = window['imToken']
  const providerUrl = await imToken.callPromisifyAPI('tron.getProvider')
  const fromAddress = TronWeb.address.toHex(from)
  const toAddress = TronWeb.address.toHex(to)
  const resource = await get(`${providerUrl}/wallet/getdelegatedresource`, { fromAddress, toAddress })

  let bp = { amount: 0, expire_time: 0 }
  let energy = { amount: 0, expire_time: 0 }

  if (Array.isArray(resource.delegatedResource)) {
    resource.delegatedResource.forEach(d => {
      if (d.from === fromAddress && d.to === toAddress) {
        if (d.frozen_balance_for_bandwidth) {
          bp = {
            amount: TronWeb.fromSun(d.frozen_balance_for_bandwidth),
            expire_time: d.expire_time_for_bandwidth,
          }
        }
        if (d.frozen_balance_for_energy) {
          energy = {
            amount: TronWeb.fromSun(d.frozen_balance_for_energy),
            expire_time: d.expire_time_for_energy,
          }
        }
      }
    })
  }
  return {
    bp,
    energy
  }
}
